/* eslint-disable filenames/match-regex */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { resources } from './resources'

let savedLng: string | null = null
// Fall back to the legacy 'yuno-lng' key so returning users keep their saved
// language after the white-label de-brand rename.
try { savedLng = localStorage.getItem('sdk-payments-lng') ?? localStorage.getItem('yuno-lng') } catch { /* storage unavailable */ }

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: savedLng ?? window.navigator.language,
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources,
  })

export default i18n
